import { WorkflowEditBlockConditionModal } from "@/pages/workflows/edit/actions/WorkflowEditBlockConditionModal.tsx";
import { resolveBlockConditionMode } from "@/pages/workflows/edit/actions/workflow-edit-block-condition-modal.tsx";
import { isCandidateWorkflowEventType } from "@/types/workflows/workflow.base-enum.types.ts";
import { ApiWorkflowCondition } from "@/types/workflows/workflow.condition.types.ts";
import { ApiWorkflowBlock, ApiWorkflowVersion } from "@/types/workflows/workflow.types.ts";
import { useModals } from "@skailer-com/uikit";
import { useRef, useState } from "react";

export const useWorkflowBlockConditions = (
  workflowVersion: ApiWorkflowVersion,
  block: ApiWorkflowBlock
) => {
  const { openModal } = useModals();

  const mode = resolveBlockConditionMode(
    isCandidateWorkflowEventType(workflowVersion.trigger_event?.event_type)
  );

  const tempIdCounter = useRef(0);
  const generateTempId = (): number => {
    tempIdCounter.current -= 1;
    return tempIdCounter.current;
  };

  const getConditionsSchemaByBlock = (blockId: number) => {
    const edge = workflowVersion.edges.find((x) => x.to_block_id == blockId);
    if (!edge) return [];
    return edge.conditions;
  };

  const [conditions, setConditions] = useState<ApiWorkflowCondition[]>(
    getConditionsSchemaByBlock(block.id)
  );

  const handleAddCondition = () => {
    openModal(WorkflowEditBlockConditionModal, {
      mode,
      onSave: (condition) => {
        setConditions((prevConditions) => [
          ...prevConditions,
          { ...condition, id: generateTempId() },
        ]);
      },
    });
  };

  const handleEditCondition = (conditionToEdit: ApiWorkflowCondition) => {
    openModal(WorkflowEditBlockConditionModal, {
      condition: conditionToEdit,
      mode,
      onSave: (updatedCondition) => {
        setConditions((prevConditions) =>
          prevConditions.map((c) => (c.id === updatedCondition.id ? updatedCondition : c))
        );
      },
    });
  };

  const handleDeleteCondition = (conditionId: number) => {
    setConditions((prevConditions) => prevConditions.filter((c) => c.id !== conditionId));
  };

  return { conditions, handleAddCondition, handleEditCondition, handleDeleteCondition };
};
